import type { VehicleWithPrice } from "@be-miniapp/api"

/**
 * Normalizes `location.state` for `/ride/in-trip` after booking navigation.
 * Accepts both string and numeric `sessionId` from different handoff paths.
 */
export function parseRideInTripRouteState(state: unknown): {
  sessionId: string
  vehicleData: VehicleWithPrice | Record<string, never>
} {
  const raw = state as Record<string, unknown> | null | undefined
  const sessionIdRaw = raw?.sessionId
  const sessionId =
    sessionIdRaw === undefined || sessionIdRaw === null
      ? ""
      : String(sessionIdRaw)
  const vehicleData = (raw?.vehicleData ?? {}) as VehicleWithPrice
  return { sessionId, vehicleData }
}
